import { getPaths } from "@/utils/helpers";

const ROOT_PATH = "/quote";

export const QUOTE = Object.freeze({
  ROOT: ROOT_PATH,
  DETAIL: `${ROOT_PATH}/detail`,
  PAX: `${ROOT_PATH}/pax`,
  DATE: `${ROOT_PATH}/date`,
  DEPARTURE_AIRPORT: `${ROOT_PATH}/departureairport`,
  FLIGHT_TIMES: `${ROOT_PATH}/flighttimes`,
} as const);

export const PATHS = Object.freeze({
  QUOTE,
} as const);

const _pathValues = getPaths(PATHS);

export type Path = (typeof _pathValues)[number];
